import { vars } from '@repo/config';

const SYSTEM_LOOKUP_TIMEOUT_MS = 3000;

export interface ISystemUser {
  userId: string;
  email: string;
  name: string;
}

interface IInternalUserResponse {
  success: boolean;
  data: ISystemUser;
}

export async function fetchUserByIdSystem(userId: string): Promise<ISystemUser | null> {
  const url = new URL(`/internal/users/${encodeURIComponent(userId)}`, vars.url.identityUrl);

  try {
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'x-service-api-key': vars.billing.serviceApiKey,
      },
      cache: 'no-store',
      signal: AbortSignal.timeout(SYSTEM_LOOKUP_TIMEOUT_MS),
    });

    if (!response.ok) {
      return null;
    }

    const body = (await response.json()) as IInternalUserResponse;
    return body.data ?? null;
  } catch {
    return null;
  }
}
